export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_42-039b765c7d0dbbf74ab7ef860f271c1b.jpg";